import React from "react";
import styled from "styled-components";
import { mdiLoading } from "@mdi/js";

const SvgStyle = styled.svg`
    fill: ${props => (props.$highlight ? props.theme.primaryLight : "currentColor")};
    transition: fill 0.3s ease;
    animation: ${props => (props.$loading ? "spin 1s linear infinite" : "none")};
    @keyframes spin {100%{transform:rotate(360deg)}}
`;

export const Svg = React.memo(props => {

    const { path, size, highlight, viewBox = "0 0 24 24", loading } = props;

    const onClick = event => {
        if (props.onClick && !loading) {
            props.onClick(event);
        }
    };

    return (
        <SvgStyle
            height={size}
            width={size}
            viewBox={viewBox}
            onClick={onClick}
            $highlight={highlight}
            $loading={loading}>
            <path d={loading ? mdiLoading : path} />
        </SvgStyle>
    );
});